import {
  Allergen,
  PricingPlan,
  nibblesProductTitleEnum,
  sprinklesProductTitleEnum,
} from "../types/enums";
import type { TSufActivityLevel, TSufBodyType } from "../types/enums";
import type { TDiscount } from "../schemas/primitives";
import {
  DIRECT_SALES_DEFAULT_DISCOUNT,
  TRIAL_PLAN_DEFAULT_DISCOUNT,
} from "./subscription-normalisation.constants";

export const defaultOngoingDeliveryFee = 2.99;
export const defaultTrialDeliveryFee = 0;

export const NIBBLES_CHICKEN_PRICE_BEFORE_DISCOUNT = 7.5;
export const NIBBLES_CHICKEN_PRICE_AFTER_DISCOUNT = 3.75;
export const NIBBLES_SALMON_PRICE_BEFORE_DISCOUNT = 7.5;
export const NIBBLES_SALMON_PRICE_AFTER_DISCOUNT = 3.75;
export const NIBBLES_TRIO_BUNDLE_PRICE_BEFORE_DISCOUNT = 5.97;
export const NIBBLES_TRIO_BUNDLE_PRICE_AFTER_DISCOUNT = 2.99;
export const NIBBLES_TRIO_BUNDLE_ALLERGENS: readonly string[] = [ Allergen.CHICKEN, Allergen.SALMON, Allergen.TUNA ];

export const SPRINKLES_PRICE_BEFORE_DISCOUNT = 0;
export const SPRINKLES_PRICE_AFTER_DISCOUNT = 0;

export const defaultDiscountCode = TRIAL_PLAN_DEFAULT_DISCOUNT.discountCode;

export const defaultUser = {
  firstName: "",
  lastName: "",
  email: "",
  marketingConsent: true,
  shippingAddress: {},
  billingAddress: {},
  id: undefined,
};

export const defaultDelivery = {
  ongoingDeliveryFee: defaultOngoingDeliveryFee,
  trialDeliveryFee: defaultTrialDeliveryFee,
  deliveryDate: undefined,
};

export const defaultDiscount: TDiscount = {
  ...TRIAL_PLAN_DEFAULT_DISCOUNT,
};

export const defaultSubscription = {
  discount: defaultDiscount,
  productType: "FRESH_TRIAL" as const,
  trial: {
    planType: PricingPlan.TRIAL,
  },
  ongoing: {
    planType: PricingPlan.STANDARD,
  },
  nibblesUpsell: {
    added: false,
    discountedPrice: NIBBLES_TRIO_BUNDLE_PRICE_AFTER_DISCOUNT,
    originalPrice: NIBBLES_TRIO_BUNDLE_PRICE_BEFORE_DISCOUNT,
    type: nibblesProductTitleEnum.enum.NIBBLES_TRIO_BUNDLE,
    quantity: 0,
  },
  sprinklesUpsell: {
    added: false,
    discountedPrice: SPRINKLES_PRICE_AFTER_DISCOUNT,
    originalPrice: SPRINKLES_PRICE_BEFORE_DISCOUNT,
    type: sprinklesProductTitleEnum.enum.SPRINKLES,
    quantity: 0,
  },
};

export const defaultDirectSalesSubscription = {
  ... defaultSubscription,
  discount: DIRECT_SALES_DEFAULT_DISCOUNT,
};

export const bodyTypes: Record<TSufBodyType, TSufBodyType> = {
  VERY_THIN: "VERY_THIN",
  THIN: "THIN",
  JUST_RIGHT: "JUST_RIGHT",
  OVERWEIGHT: "OVERWEIGHT",
  VERY_OVERWEIGHT: "VERY_OVERWEIGHT",
};

export const activityLevels: Record<TSufActivityLevel, TSufActivityLevel> = {
  INDOOR_LOW_ACTIVITY: "INDOOR_LOW_ACTIVITY",
  INDOOR_HIGH_ACTIVITY: "INDOOR_HIGH_ACTIVITY",
  INDOOR_AND_OUTDOOR: "INDOOR_AND_OUTDOOR",
  MOSTLY_OUTDOOR: "MOSTLY_OUTDOOR",
};
